import { jsx } from 'react/jsx-runtime';
import { EmeraldBadgeCoreInputs, EmeraldBadgeVariant } from '@emerald/nxcore';

var classnames = {exports: {}};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

(function (module) {
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
}(classnames));

var cx = classnames.exports;

class EmeraldBadgeInputs extends EmeraldBadgeCoreInputs {}

const EmeraldBadge = props => {
  var _a, _b;
  const VARIANT = ((_a = props === null || props === void 0 ? void 0 : props.badgeCount) === null || _a === void 0 ? void 0 : _a.length) && ((_b = props === null || props === void 0 ? void 0 : props.badgeCount) === null || _b === void 0 ? void 0 : _b.length) > 1 ? EmeraldBadgeVariant.NUMBER_LARGE : EmeraldBadgeVariant.DOT;
  return jsx("div", {
    className: cx('emerald-badge', props.className),
    title: props.title,
    children: jsx("div", {
      className: cx('badge-container', `${props.size}`, {
        'emerald-badge-large': VARIANT === EmeraldBadgeVariant.NUMBER_LARGE,
        disable: props.disabled
      }),
      children: props.badgeCount
    })
  });
};
EmeraldBadge.defaultProps = new EmeraldBadgeInputs();
EmeraldBadge.displayName = 'EmeraldBadge';

export { EmeraldBadge, EmeraldBadgeInputs };
